package ru.it_mozaika.sender.js.application.components.users

import ru.it_mozaika.sender.common.EMAIL_REGEX
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.onChange
import ru.it_mozaika.sender.common.models.CreateUserRequest
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.styles.styledDialog
import web.cssom.AlignItems
import web.cssom.px
import web.html.HTMLInputElement
import web.html.InputType

external interface AddUserDialogProps: Props {
    var handleOnSubmit: (CreateUserRequest) -> Unit
    var handleOnClose: () -> Unit
    var isOpen: Boolean
}

val addUserDialog = FC<AddUserDialogProps> { props ->

    val (newEmail, setNewEmail) = useState<String>("")
    val (newRole, setNewRole) = useState<UserRole>()
    val (name, setName) = useState<String>()
    val (lastName, setLastName) = useState<String>()

    val checkEmail = {
        newEmail.matches(EMAIL_REGEX)
    }
    val checkRole = {
        UserRole.values().find { it == newRole} != null
    }


    val ref = useRef<HTMLInputElement>(null)

    Dialog {

        open = props.isOpen
        onClose = { _, _ ->
            props.handleOnClose()
        }
        DialogTitle {
            +"Внесите данные пользователя"
        }
        DialogContent {
            Stack{
                direction = responsive(StackDirection.column)
                asDynamic().spacing = 2
                TextField {
                    sx{
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "email-field"
                    label = ReactNode("email")
                    required = true
                    type = InputType.text
                    fullWidth = true
                    variant = FormControlVariant.outlined
                    error = !checkEmail()
                    this.onChange = {event ->
                        val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                        setNewEmail(newValue)
                    }
                }
                TextField {
                    sx{
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "name-field"
                    label = ReactNode("Имя")
                    required = true
                    type = InputType.text
                    fullWidth = true
                    error = name.isNullOrBlank()
                    variant = FormControlVariant.outlined
                    this.onChange = {event ->
                        val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                        setName(newValue)
                    }
                }
                TextField {
                    sx{
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "last-name-field"
                    label = ReactNode("Фамилия")
                    type = InputType.text
                    fullWidth = true
                    error = lastName.isNullOrBlank()
                    required = true
                    variant = FormControlVariant.outlined
                    this.onChange = {event ->
                        val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                        setLastName(newValue)
                    }
                }
                FormControl{
                    variant = FormControlVariant.outlined
//                    this.color = FormControlColor.primary
                    fullWidth = true
//                size = Size.large
                    sx{
                        minWidth = 100.px
                    }
                    InputLabel {
                        id = "role-select-lable"
                        +"Уровень доступа"
                    }
                    Select {
                        error = !checkRole()
                        required = true
                        labelId = "role-select-label"
                        id = "role-select"
                        this.value = newRole?.name ?: ""
                        label = ReactNode(newRole?.name ?: "")
                        onChange = { event, _ ->
                            val value = event.target.value
                            setNewRole(UserRole.values().find{it.name == value})
                        }
                        UserRole.values().forEach { role ->
                            MenuItem{
                                value = role.name
                                + role.name
                            }

                        }

                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx {
          alignItems = AlignItems.flexEnd
                }
                direction = responsive(StackDirection.row)
                asDynamic().spacing = 2

                Button {
                    disabled = !checkRole() || !checkEmail() || name.isNullOrBlank()|| lastName.isNullOrBlank()
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.handleOnSubmit(CreateUserRequest(email = newEmail, name = name ?: "", lastName  = lastName ?: "", role = newRole!!))
                        props.handleOnClose()
                    }
                    +"Создать"
                }
                Button {
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.handleOnClose()
                    }
                    +"Отмена"
                }
            }
        }
    }
}